module.exports = __webpack_public_path__ + "static/pic09-ecc0f7a2940f6c15091576f460f4c048.jpg";